import React,{useEffect} from 'react';
import '../PaytmUI/PaytmUI.css';
import ReactGA from 'react-ga';

const PaytmCallback = () => {
    const { PUBLIC_URL } = process.env;
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const isSuccess = params.get('success');
    const message = params.get('message');


   useEffect(() => {
        const { REACT_APP_GA } = process.env;
        if(REACT_APP_GA) {
            ReactGA.initialize(REACT_APP_GA);
            ReactGA.pageview(window.location.pathname + window.location.search);
        };

    },[]);

    return (
        <>  
    <div className="payment-wrap">
        <div className="payment-left">
            <div className="payment-image-wrap">
                <img src="/images/wallet-payment.svg" alt="Wallet" />
            </div>
        </div>
        <div className="payment-right">
            <div className="logo-payment">
                <img src="/images/logo.svg" alt="Mintifi Logo" />
            </div>
             {isSuccess === "true" ?
                <>
               <div>
                    <h2 className="thankyou-main-text">Thank You!</h2>
                    <p className="thankyou-inner-text">{message}</p>
                </div>
                <div className="col-md-3 sub-btn mt-3 dispFlex padd0 m-auto">
                    <div className="paddlr20 m-auto grid padd0">
                        <button className="butn butnBlue form-grp" onClick={() => window.location.href = `${PUBLIC_URL}/paytm`}>Done </button>
                    </div>
                </div>
                 </>
                :
               <>
                     <div>
                        <h2 className="something-wrong-text">Something went wrong</h2>
                        <p className="something-wrong-inner-text">{message || 'Your transaction has failed. Please re-try your Payment.'}</p>
                    </div>
                    <div className="col-md-3 sub-btn mt-3 dispFlex padd0 m-auto">
                        <div className="paddlr20 m-auto grid padd0">
                            <button type="button" className="butn form-grp" style={{background :"#E5541F"}} onClick={() => window.location.href = `${PUBLIC_URL}/paytm`}>Retry</button>
                        </div>
                    </div>
                </>
            }
            </div>
        </div>
        </>
    )
}

export default PaytmCallback;
